import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "aws-amplify";
import { api, extractAmplifyStandardResponseData, extractStandardResponseData } from "src/api/api";
import { User } from "src/interfaces/User";

//create new user
export const createNewUser = createAsyncThunk(
  "admin/create-user",
  async (user: User) =>
    await API.post("api", "users/", { body: user }).then(extractAmplifyStandardResponseData)
  // await api.post("/users", user).then(extractStandardResponseData)
);

//bulk upload users
export const createMultipleUsers = createAsyncThunk(
  "admin/create/multiple",
  async (formData: FormData) =>
    await api.post("/admin/uploadCsv", formData).then((res) => res.data)
);

//get users page
export const getUsers = createAsyncThunk(
  "admin/users",
  async ({ page }: { page: number }) =>
    await API.get("api", `admin/users?search=&page=${page}`, {})
  // await api.get(`admin/users?search=&page=${page}`).then((res) => res.data)
);

//edit a user
export const editUser = createAsyncThunk(
  "admin/edit-user",
  async (user: User) =>
    await API.patch("api", `users/${user.id}/`, { body: user }).then(extractAmplifyStandardResponseData)
  // await api.patch(`/users/${user.id}`, user).then(extractStandardResponseData)
);

// activate or deactivate user
export const activateDeativateUser = createAsyncThunk(
  "admin/activate-user",
  async ({ userId, active }: any) =>
    await API.patch("api", `users/deactivate/${userId}/`, { body: { value: active } })
  // await api
  //   .patch(`/users/deactivate/${userId}`, { value: active })
  //   .then(extractStandardResponseData)
);

//delete user
export const deleteUser = createAsyncThunk(
  "admin/delete-user",
  async (userId: number) => {
    await API.del("api", `users/${userId}/`, {})
    // await api.delete(`/users/${userId}`).then(extractStandardResponseData);
    return userId;
  }
);

export const clearPaginations = createAsyncThunk(
  "session/paginations/clear",
  () => { }
);
